if (!customElements.get('gift-recipient')) {
  customElements.define(
    'gift-recipient',
    class GiftRecipient extends HTMLElement {
      connectedCallback() {
        this.toggle = this.querySelector('[data-gift-toggle]');
        this.fieldset = this.querySelector('fieldset');

        this.onToggle = this.onToggle.bind(this);
        this.onAddToCart = this.onAddToCart.bind(this);
        this.toggle.addEventListener('change', this.onToggle);
        // Capture on window runs before product-form.js and before cart apps that hook the add-to-cart button click.
        window.addEventListener('click', this.onAddToCart, true);
        window.addEventListener('submit', this.onAddToCart, true);

        this.onToggle();
      }

      disconnectedCallback() {
        window.removeEventListener('click', this.onAddToCart, true);
        window.removeEventListener('submit', this.onAddToCart, true);
      }

      onToggle() {
        const isGift = this.toggle.checked;
        this.fieldset.disabled = !isGift;
        this.fieldset.hidden = !isGift;

        // Dynamic checkout ("Buy it now") can't be validated, so hide it for gifts.
        const paymentButton = document.getElementById(this.dataset.formId)?.querySelector('.shopify-payment-button');
        if (paymentButton) paymentButton.hidden = isGift;
      }

      onAddToCart(evt) {
        if (!this.toggle.checked) return;

        const form =
          evt.type === 'submit' ? evt.target : evt.target.closest?.('button[type="submit"], input[type="submit"]')?.form;
        if (!form || form.id !== this.dataset.formId) return;

        const invalid = Array.from(this.fieldset.querySelectorAll('input')).find((input) => !input.checkValidity());
        if (!invalid) return;

        evt.preventDefault();
        evt.stopImmediatePropagation();
        invalid.reportValidity();
      }
    }
  );
}
